import type { CvContent } from './types'

export const de: CvContent = {
  tagline: 'Performerin · Tänzerin · Sängerin · Tanzdozentin',
  intro:
    'Studentin BA Tanz / BA Tanzpädagogik am Lucia Marthas Institute for Performing Arts. Bühnenerfahrung u. a. in der Ziggo Dome, in Ahoy und AFAS Live sowie Dance Captain der jährlichen LMIPA-Abschlusspräsentation.',
  about:
    'Ich bin eine begeisterte und flexible Performerin mit einem großen Verantwortungsbewusstsein. Ich bin zuverlässig, immer pünktlich und gebe nicht so schnell auf. Ich arbeite organisiert, behalte meine Aufgaben im Blick und bin eine Teamplayerin, die bei Bedarf schnell umschaltet. Neben meiner Arbeit auf der Bühne unterrichte ich sehr gerne und gebe meine Leidenschaft für Musical und darstellende Künste an andere weiter. Mit meiner positiven Energie und meinem Engagement trage ich zu einer reibungslosen und erfolgreichen Produktion bei.',
  features: [
    { label: 'Haarfarbe', value: 'Blond' },
    { label: 'Augen', value: 'Blau' },
    { label: 'Größe', value: '1,70 m' },
    { label: 'Geburtsdatum', value: '27.03.2005' },
  ],
  skills: [
    {
      heading: 'Gesang',
      lines: ['Stimmlage: Sopran', 'Stimmumfang: E3 bis C6', 'Ausbildung in:'],
      items: ['Jazz', 'Musical', 'Pop', 'Klassik', 'Ensemble und Mehrstimmigkeit'],
    },
    {
      heading: 'Tanz',
      lines: ['Ausbildung in:'],
      items: [
        'Ballett',
        'Jazz',
        'Horton',
        'Modern',
        'Verschiedene Latin-Stile und Hebefiguren',
        'Musicaltheater',
        'Commercial',
        'Stepptanz',
      ],
    },
    {
      heading: 'Schauspiel',
      lines: [],
      items: [
        'Improvisation',
        'Gruppenszenen',
        'Monologe',
        'Duologe',
        'Theater- und Kameraschauspiel',
      ],
    },
  ],
  experience: [
    {
      title: 'Jährliche Abschlusspräsentation LMIPA',
      period: 'Juli 2014 – heute',
      description:
        'Bei der jährlichen Abschlusspräsentation war ich als Dance Captain für verschiedene Stücke verantwortlich. Außerdem habe ich Choreografien für die jüngeren Abteilungen erstellt und dabei meine Kreativität und Erfahrung als Tanzdozentin eingesetzt.',
    },
    { title: 'Christmas Show, Ziggo Dome', period: 'Dez 2016' },
    { title: 'Kinderen voor Kinderen 40 Jahre, Ahoy', period: '2018' },
    { title: 'Lang Leve de Muziek Show AVROTROS', period: '2018 – 2019' },
    { title: 'Katja en Babbette Discobal, AFAS Live', period: 'Nov 2025' },
    {
      title: 'Workshops',
      period: '2023 – heute',
      bullets: [
        'Workshops/Unterricht bei Malou Linders, Denden Karadeniz, Sergio Reis, Jordy Sparidaens, Anneke Ghysens und Laurent Flamment',
        'Workshops/Unterricht bei Caroline Dijkhuizen, Andy Señor JR, Mary-Ann Lamb, Valerie Pettifort und Michiel Varga',
      ],
    },
    {
      title: 'Tanzdozentin, Lucia Marthas Institute for Performing Arts',
      period: 'Sept 2023 – heute',
    },
  ],
  education: [
    {
      period: '2023',
      school: 'Gerrit van der Veen College',
      detail: 'VWO / DAMU-Klasse LMIPA',
    },
    {
      period: 'Sept 2023 – Juli 2027',
      school: 'Lucia Marthas Institute for Performing Arts',
      detail: 'BA Tanz / BA Tanzpädagogik',
    },
  ],
}
